import React from "react";
import PhoneNav from "../PhoneNav";
import Property1Default from "../Property1Default";
import Footer4 from "../Footer4";
import "./Services.css";

function Services(props) {
  const { ourServices, sohniJunejaIsAWe, phoneNavProps, property1DefaultProps } = props;

  return (
    <div className="services-1 screen">
      <PhoneNav image22={phoneNavProps.image22} className={phoneNavProps.className} />
      <div className="frame-49">
        <div className="our-services poppins-medium-tundora-18px">{ourServices}</div>
      </div>
      <div className="frame-286">
        <p className="sohni-juneja-is-a-we montserrat-normal-tundora-10px">{sohniJunejaIsAWe}</p>
      </div>
      <div className="frame-287">
        <Property1Default {...property1DefaultProps} />
      </div>
      <Footer4 />
    </div>
  );
}

export default Services;
